<template>
    <div>
        <div class="box">
            <!-- 内容区域 -->
            <div class="box_content">
                <TabTime
                    @onChangeTime="onChangeTime"
                    :titleText="'自来水营收数据'" />
                <div class="title">
                    <span class="blue-title"></span>
                    <span class="title-text">营收数据</span>
                </div>
                <div class="data-item2">
                    <div class="item-six">
                        <div>
                            <div>
                                <span
                                    class="number"
                                    >{{ (tapWaterData.periodActualPay / 10000).toFixed(2) }}</span
                                ><span class="danwei">万</span>
                            </div>
                            <div class="total-mo">营收额</div>
                        </div>
                        <div class="tooline" style="color: black;"></div>
                                <div>
                            <div>
                                <span
                                    class="number"
                                    >{{ (tapWaterData.monthRevenue / 10000).toFixed(2) }}</span
                                ><span class="danwei">万</span>
                            </div>
                            <div class="total-mo">当月营收额</div>
                        </div>
                        <div class="tooline"></div>
                        <div>
                            <div>
                                <span
                                    class="number"
                                    >{{ tapWaterData.totalUsers }}</span
                                ><span class="danwei"></span>
                            </div>
                            <div class="total-mo">用户量</div>
                        </div>  
                          <div class="tooline"></div>
                    </div>
                    
                    <div class="item-six">
                      <div>
                            <div>
                                <span
                                    class="number"
                                    >{{ tapWaterData.periodNewUsers }}</span
                                >
                            </div>
                            <div class="total-mo">新增用户量</div>
                        </div>
                          <div class="tooline"></div>
                        <div>
                            <div>
                                <span
                                    class="number"
                                    >{{ (tapWaterData.periodDosage / 10000).toFixed(2) }}</span
                                ><span class="danwei">万方</span>
                            </div>
                            <div class="total-mo">销水量</div>
                        </div>  
                     <div class="tooline"></div>
                        <div>
                            <div>
                                <span
                                    class="number"
                                    >{{ (tapWaterData.periodMeterDosage / 10000).toFixed(2) }}</span
                                ><span class="danwei">万方</span>
                            </div>
                            <div class="total-mo">抄表水量</div>
                        </div>
                        
                    </div>
                    <div class="item-six">
                       <div>
                            <div>
                                <span
                                    class="number"
                                    >{{ (tapWaterData.totalDosage / 10000).toFixed(2) }}</span
                                ><span class="danwei">万方</span>
                            </div>
                            <div class="total-mo">总销水量</div>
                        </div>
                        <div class="tooline"></div>
                        <div>
                            <div>
                                <span
                                    class="number"
                                    >{{ (tapWaterData.totalMeterDosage / 10000).toFixed(2) }}</span
                                ><span class="danwei">万方</span>
                            </div>
                            <div class="total-mo">总抄表量</div>
                        </div>   
                   </div>
                </div>
                <div class="title">
                    <span class="blue-title"></span>
                    <span class="title-text">自来水营收数据增长趋势</span>
                </div>
                <!-- 折线图容器 -->
                <div class="chart-container">
                    <div id="trendChart" class="chart"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TabTime from './tabTime.vue'
// import api from '../api/index'
import {shortcuts} from '../utils/index'
import * as echarts from 'echarts';

export default {
  name: 'WaterPage',
  components: {
    TabTime
  },
  data() {
    return {
      currentPage: 'WaterPage',
      currentTime: '',
      formattedDate: "",
      currentDay: "",
      tapWaterData: { },
      chart: null,
      chartData: {
        dates: [],
        revenues: [],
        visitors: []
      }
    };
  },
  mounted() {
    this.getCurrentDate();
    this.updateTime();
    this.tapWaterApi(shortcuts(1));
    // 初始化图表
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    // 组件销毁时销毁图表
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    updateTime() {
      setInterval(() => {
        this.currentTime = new Date().toLocaleTimeString();
      }, 1000);
    },
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const daysOfWeek = ["日", "一", "二", "三", "四", "五", "六"];
      this.formattedDate = `${year}-${month}-${day}`;
      this.currentDay = "星期" + daysOfWeek[date.getDay()];
    },
    onChangeTime(message) {
      this.tapWaterApi(message.date);
    },
  async tapWaterApi(date) {
  try {
    const [startDate, endDate] = date;

    const formatDate = (dateObj) => {
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const response = await fetch(
      `http://117.33.227.88:8788/statistics/getzilaishui?startDay=${formatDate(startDate)}&endDay=${formatDate(endDate)}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const res = await response.json();
    this.processResponseData(res);

  } catch (error) {
    console.error('获取数据失败:', error);
  }
},

processResponseData(res) {
  const summary = res.summary || {};
  const dailyList = res.dailyList || [];

  const toNumber = (value) => {
    if (typeof value === 'string') {
      return parseFloat(value) || 0;
    }
    return value || 0;
  };

  this.tapWaterData = {
    periodActualPay: toNumber(summary.periodActualPay),
    periodDosage: toNumber(summary.periodDosage),
    periodMeterDosage: toNumber(summary.periodMeterDosage),
    periodNewUsers: toNumber(summary.periodNewUsers),
    totalActualPay: toNumber(summary.totalActualPay),
    totalDosage: toNumber(summary.totalDosage),
    totalMeterDosage: toNumber(summary.totalMeterDosage),
    totalUsers: toNumber(summary.totalUsers),
    monthRevenue:toNumber(res.monthRevenue)

  };

  // 准备图表数据
  this.prepareChartData(dailyList);

  // 更新图表
  this.updateChart();
},
     prepareChartData(dailyList) {
      // 按日期排序
      const sortedList = [...dailyList].sort((a, b) => {
        return new Date(a.startDay) - new Date(b.startDay);
      });

      this.chartData = {
        dates: sortedList.map(item => item.startDay),
        revenues: sortedList.map(item => item.periodActualPay || 0),
        visitors: sortedList.map(item => item.periodDosage || 0)
      };
},
     initChart() {
  const chartDom = document.getElementById('trendChart');
  this.chart = echarts.init(chartDom);

  const option = {
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      borderColor: '#ccc',
      borderWidth: 1,
      textStyle: { color: '#333' },
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      },
      formatter: (params) => {
        let result = `<div style="font-weight: bold;">${params[0].name}</div>`;
        params.forEach(param => {
          let value = param.value;
          let unit = param.seriesName.includes('净营收') ? '万元' : '万方';
          let formattedValue = param.seriesName.includes('净营收')
            ? (value / 10000).toFixed(2) + '万元'
            :  (value / 10000).toFixed(2)  + unit;
          result += `<div>${param.seriesName}: ${formattedValue}</div>`;
        });
        return result;
      }
    },
    legend: {
      data: ['净营收', '销水量'],
      top: '5%',
      left: 'center',
      textStyle: {
        color: 'white',
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      top: '15%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: this.chartData.dates,
      axisLabel: {
        rotate: 45,
        interval: 'auto',
        formatter: (value) => {
          return value ? value.substring(5) : '';
        }
      },
      axisLine: {
        lineStyle: {
          color: '#ccc'
        }
      }
    },
    yAxis: [
      {
        type: 'value',
        name: '净营收(万元)',
        min: 0,
        axisLabel: {
          formatter: '{value}'
        },
        axisLine: {
          lineStyle: {
            color: '#67a0ef'
          }
        },
        splitLine: {
          lineStyle: {
            color: '#eee'
          }
        }
      },
      {
        type: 'value',
        name: '销水量(万方)',
        min: 0,
        axisLabel: {
          formatter: '{value}'
        },
        axisLine: {
          lineStyle: {
            color: '#ff7f50'
          }
        },
        splitLine: {
          show: false
        }
      }
    ],
    series: [
      {
        name: '净营收',
        type: 'line',
        yAxisIndex: 0,
        data: this.chartData.revenues,
        symbol: 'circle',
        symbolSize: 6,
        color: '#67a0ef',
        lineStyle: {
          width: 2
        },
        areaStyle: {
          opacity: 0.2,
          color: '#67a0ef'
        },
        emphasis: {
          focus: 'series'
        }
      },
      {
        name: '销水量',
        type: 'line',
        yAxisIndex: 1,
        data: this.chartData.visitors,
        symbol: 'circle',
        symbolSize: 6,
        color: '#ff7f50',
        lineStyle: {
          width: 2
        },
        areaStyle: {
          opacity: 0.2,
          color: '#ff7f50'
        },
        emphasis: {
          focus: 'series'
        }
      }
    ]
  };

  this.chart.setOption(option);

  // 响应式调整
  window.addEventListener('resize', this.handleResize);
},

updateChart() {
  if (!this.chart) return;

  const option = {
    xAxis: {
      data: this.chartData.dates
    },
    series: [
      {
        data: this.chartData.revenues
      },
      {
        data: this.chartData.visitors
      }
    ]
  };

  this.chart.setOption(option);
},
  }
}
</script>

<style scoped>

* {
  margin: 0;
  padding: 0;
}
.box {
  width: 100%;
  margin-top: -3.9%;
  color: rgb(255, 255, 255);
  /* background: linear-gradient(135deg, #b0d957 0%,#558d40 42%, #457f4d 100%); */
  background: #ffffff;
}

.box_content {
  margin: 0 10px;
}

.title {
  display: flex;
  padding: 14px 0;
  justify-content: flex-start;
}

.blue-title {
  width: 3px;
  height: 16px;
  background-color: #50ba96;
  margin-right: 8px;
}

.title-text {
  font-size: 14px;
 color: #606060;
}

.data-item2 {
  padding: 24px 13px;
  display: flex;
  flex-direction: column;
}

.item-six {
  display: flex;
  justify-content: space-between;
  padding-bottom: 21px;
}

.tooline {
  width: 1px;
  height: 16px;
  background-color: #666666;
}

.number {
  font-size: 20px;
  font-weight: 700;
  color: #666666;
}

.danwei {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
}

.total-mo {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
}
.chart-container {
  z-index: 9999;
  width: 100%;
  height: 180px;
  background: #f7f7f7 ;
 }
.chart {
  width: 100%;
  height: 100%;
}
</style>
